module.exports = __webpack_public_path__ + "img/MU.b910a1dd.jpg";